import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';

// Function to notify VS Code extension that webview is ready
function markedReady() {
  try {
    // Check if we're in a VS Code webview context
    if (typeof window.acquireVsCodeApi !== 'undefined') {
      const vscode = window.acquireVsCodeApi();

      vscode.postMessage({
        type: 'webviewReady',
        source: 'subscription_dashboard'
      });
    } else if (window.parent !== window) {
      // Fallback: use postMessage to parent window
      window.parent.postMessage({
        type: 'webviewReady',
        source: 'subscription_dashboard'
      }, '*');
    }
  } catch (error) {
    // Silently fail if we can't send the ready message
    console.debug('Could not send webview ready message:', error);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Notify parent that webview is ready after React renders
// Use a small delay to ensure everything is initialized
setTimeout(() => {
  markedReady();
}, 100);

// Also expose markedReady globally in case it's called from elsewhere
if (typeof window !== 'undefined') {
  window.markedReady = markedReady;
}
